import React, { Component } from 'react'
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import Authentication from '../../../session';
import { connect } from 'react-redux';
import withRouter from '../../../lib/withRouter';
import { getBoardsData } from '../../../../store/actions';
import { userAssignedBoards } from '../../../../store/selectors/userAssignedBoards';
import AdhocList from './adhocList';
import OfflineTestList from './offlineTestList';
import "./styles.scss"
import CreateAdhoc from '../createTest'; // This is your main create component
import { baseUrlAdmin } from '../../../../store/apiConstants';

export class TestsandExam extends Component {
    constructor(props) {
        super(props)

        this.state = {
            editExamId: null,
            editExamType: null,
            cloneExamData: null,
            cloneExamType: null,
            testMode: 'online', // Default to online
            currentStep: 1
        }
    }

    componentDidMount() {
        if (!this.props.boards || !this.props.boards.length) {
            this.props.getBoardsData(true);
        }

        // Check if we're coming from an edit URL
        const urlParams = new URLSearchParams(window.location.search);
        const examId = urlParams.get('editExamId');
        const examType = urlParams.get('editExamType');
        const cloneExamId = urlParams.get('cloneExamId');
        const cloneExamType = urlParams.get('cloneExamType');

        if (examId && examType) {
            this.setState({
                editExamId: examId,
                editExamType: examType,
                testMode: examType === 'OfflineTest' ? 'offline' : 'online',
                currentStep: 1
            });
        } else if (cloneExamId && cloneExamType) {
            this.setState({
                cloneExamData: { examId: cloneExamId },
                cloneExamType: cloneExamType,
                testMode: cloneExamType === 'OfflineTest' ? 'offline' : 'online',
                currentStep: 1
            });
        }
    }

    getCurriculumData = (isEdit) => {
        const { boardId, classId, groupId } = this.state;

        if (boardId && classId) {
            this.setState({
                isLoading: true
            });

            this.service.get(`${baseUrlAdmin}/curriculum/getByGrades?boardId=${boardId}&classId=${classId}${groupId ? `&groupId=${groupId}` : ''}`, true)
                .then((data) => {
                    if (data && data.status && data.res.data && data.res.data.length > 0) {
                        const subjects = data.res.data;

                        if (isEdit) {
                            // If in edit mode, match subjects with the exam's subjects
                            const { exam } = this.state;

                            if (exam && exam.subjects) {
                                // Set subject IDs based on the loaded exam data
                                setTimeout(() => {
                                    const updatedExam = { ...exam };

                                    // Make sure subject references are updated
                                    if (updatedExam.subjects && updatedExam.subjects.length > 0) {
                                        updatedExam.subjects.forEach(subj => {
                                            const matchedSubject = subjects.find(s => s.subjectId === subj.subjectId);
                                            if (matchedSubject) {
                                                subj.subjectName = matchedSubject.subjectName;
                                            }
                                        });
                                    }

                                    this.setState({
                                        exam: updatedExam
                                    });
                                }, 300);
                            }
                        }

                        this.setState({
                            subjects,
                            isLoading: false
                        });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                    }
                })
                .catch(e => {
                    this.setState({
                        isLoading: false
                    });
                });
        } else {
            if (isEdit) {
                this.toast.show({
                    severity: 'warn',
                    summary: 'Missing Data',
                    detail: 'Board or class information is missing',
                    life: 3000
                });
            }
        }
    };

    onExamEditSuccess = () => {
        // Clear URL parameters and state
        this.props.navigate('/TestsAndExams');

        this.setState({
            editExamType: null,
            editExamId: null,
            cloneExamData: null,
            cloneExamType: null,
        });

        this.toast.show({
            severity: 'success',
            summary: 'Success',
            detail: 'Exam saved successfully',
            life: 3000
        });
    }

    onCloneExam = (examId, examType) => {
        console.log("Clone exam clicked with data:", examId, examType);

        if (!examId) {
            console.error("Invalid exam data received:", examId);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Could not clone exam: Invalid exam data',
                life: 3000
            });
            return;
        }

        // Navigate to clone URL with parameters
        this.props.navigate(`/TestsAndExams?cloneExamId=${examId}&cloneExamType=${examType}`);

        // Set testMode based on examType when cloning
        const testMode = examType === 'OfflineTest' ? 'offline' : 'online';

        this.setState({
            cloneExamData: { examId },
            cloneExamType: examType,
            testMode: testMode,
            currentStep: 1,
            editExamId: null,
            editExamType: null
        });
    }

    onEditExam = (examId, examType) => {
        console.log("Edit exam clicked with data:", examId, examType);

        if (!examId) {
            console.error("Invalid exam data received:", examId);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Could not edit exam: Invalid exam data',
                life: 3000
            });
            return;
        }

        // Navigate to edit URL with parameters
        this.props.navigate(`/TestsAndExams?editExamId=${examId}&editExamType=${examType}`);

        // Set testMode based on examType when editing
        const testMode = examType === 'OfflineTest' ? 'offline' : 'online';

        this.setState({
            editExamId: examId,
            editExamType: examType,
            testMode: testMode,
            currentStep: 1
        });
    }

    onCancelEdit = () => {
        // Navigate back to main list without parameters
        this.props.navigate('/TestsAndExams');

        this.setState({
            editExamId: null,
            editExamType: null,
            cloneExamData: null,
            cloneExamType: null,
            testMode: 'online',
            currentStep: 1
        });
    }

    // Handler to receive currentStep updates from CreateAdhoc component
    onStepChange = (step) => {
        this.setState({ currentStep: step });
    }

    // Helper method to determine dropdown visibility
    shouldShowDropdown = () => {
        const { testMode, currentStep, editExamId, cloneExamData } = this.state;

        // Don't show if in edit mode or clone mode
        if (editExamId || cloneExamData) return false;

        // For offline mode, always show dropdown (no steps)
        if (testMode === 'offline') return true;

        // For online mode, hide dropdown when on step 2
        if (testMode === 'online' && currentStep === 2) return false;

        return true;
    }

    render() {
        const { editExamId, editExamType, cloneExamData, cloneExamType, testMode } = this.state;

        return (
            <>
                <div className='tests-exam-container'>
                    {/* Test Mode Selection at the top - Show based on conditions */}
                    {this.shouldShowDropdown() && (
                        <div className='ma-p20 paper-s1 mb-3'>
                            <div className="grid">
                                <div className="col-4">
                                    <p className='ma-label-s2'>Test Mode<span className='ma-required'>*</span></p>
                                    <Dropdown
                                        value={testMode}
                                        options={[
                                            { label: 'Online', value: 'online' },
                                            { label: 'Offline', value: 'offline' }
                                        ]}
                                        className='w-full'
                                        onChange={e => this.setState({ testMode: e.value, currentStep: 1 })}
                                        placeholder="Select Test Mode"
                                    />
                                </div>
                            </div>
                        </div>
                    )}

                    <div className='mt-4'>
                        {/* Show edit form if in edit mode */}
                        {editExamId ? (
                            <div>
                                {/* Breadcrumb/Back button */}
                                {/* <div className="mb-3">
                                    <button
                                        className="p-button p-button-text p-button-sm"
                                        onClick={this.onCancelEdit}
                                    >
                                        <i className="pi pi-arrow-left mr-2"></i>
                                        Back to {testMode === 'online' ? 'Online' : 'Offline'} Tests
                                    </button>
                                </div> */}

                                <CreateAdhoc
                                    onCreateSuccess={this.onExamEditSuccess}
                                    onCancel={this.onCancelEdit}
                                    editExamId={editExamId}
                                    editExamType={editExamType}
                                    onStepChange={this.onStepChange}
                                />
                            </div>
                        ) : cloneExamData ? (
                            <div>
                                {/* Breadcrumb/Back button for clone */}
                                {/* <div className="mb-3">
                                    <button
                                        className="p-button p-button-text p-button-sm"
                                        onClick={this.onCancelEdit}
                                    >
                                        <i className="pi pi-arrow-left mr-2"></i>
                                        Back to {testMode === 'online' ? 'Online' : 'Offline'} Tests
                                    </button>
                                </div> */}

                                <CreateAdhoc
                                    onCreateSuccess={this.onExamEditSuccess}
                                    onCancel={this.onCancelEdit}
                                    cloneExamData={cloneExamData}
                                    cloneExamType={cloneExamType}
                                    onStepChange={this.onStepChange}
                                />
                            </div>
                        ) : (
                            // Show appropriate list based on test mode
                            testMode === 'online' ? (
                                <AdhocList
                                    editExamType="AdhocMockTest"
                                    onEditExam={this.onEditExam}
                                    onCloneExam={this.onCloneExam}
                                />
                            ) : (
                                <OfflineTestList
                                    editExamType="OfflineTest"
                                    onEditExam={this.onEditExam}
                                    onCloneExam={this.onCloneExam}
                                />
                            )
                        )}
                    </div>
                </div>
                <Toast ref={(el) => this.toast = el} position="bottom-right" />
            </>
        );
    }
}

const mapStatesToProps = (state) => ({
    boards: userAssignedBoards(state, 'activeBoards'),
    userInfo: state.currentUserPerms?.userInfo || {},
});

export default connect(mapStatesToProps, { getBoardsData })(Authentication(withRouter(TestsandExam)));